 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTFORMATIO from '@/components/Text/Formatio'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTWORDFROMAUTHOR from '@/components/Text/WordfromAuthor'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTCHAP1 from '@/components/Text/chap1'
 import TEXTCHAP2 from '@/components/Text/chap2'
 import TEXTCHAP3 from '@/components/Text/chap3'
 import TEXTCHAP4 from '@/components/Text/chap4'
 import TEXTCHAP5 from '@/components/Text/chap5'
 import TEXTCHAP6 from '@/components/Text/chap6'
 import TEXTCHAP7 from '@/components/Text/chap7'
 import TEXTCHAP8 from '@/components/Text/chap8'
 import TEXTCHAP9 from '@/components/Text/chap9'
 import TEXTEPILOGUE from '@/components/Text/epilogue'
 import TEXTAPPENDIX from '@/components/Text/Appendix'
 import TEXTENOTES from '@/components/Text/eNotes'
 import TEXTSCRIPINDX from '@/components/Text/ScripIndx'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTALSOAVAIL from '@/components/Text/AlsoAvail'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/title",
 			"name" : "Text/title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/Formatio",
 			"name" : "Text/Formatio",
 			"component" : TEXTFORMATIO
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/dedication",
 			"name" : "Text/dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/WordfromAuthor",
 			"name" : "Text/WordfromAuthor",
 			"component" : TEXTWORDFROMAUTHOR
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/chap1",
 			"name" : "Text/chap1",
 			"component" : TEXTCHAP1
 		},
 		{
 			"path" : "/Text/chap2",
 			"name" : "Text/chap2",
 			"component" : TEXTCHAP2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js